import { QueryKey, useMutation, useQueryClient } from '@tanstack/react-query';
import { useAxios } from 'context/AxiosContextProvider';

import config from '../../config';
export default function useDeleteChainMutation(queryKey: QueryKey) {
  const axios = useAxios();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (chainId: number) => {
      return axios.delete(`${config.apiBaseUrl}/op/v1/chain/${chainId}`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });
}
